import { ExpandingTooltip } from "./ExpandingTooltip";

export { NotesPanel as TTNotesPanel, NotesPanelButton as TTNotesPanelButton };
// Item 80
const NotesPanel: ExpandingTooltip = () => {
  return <p>Add notes to be stored with this template.</p>;
};
// Item 81
const NotesPanelButton: ExpandingTooltip = (short) => {
  if (short) return <p>Click to add a new note.</p>;
  return (
    <>
      <p>
        Add notes as required. All Accelerator users that have access rights to
        view the template will be able to see the notes. Notes cannot be
        deleted. When a new note is added, it is not saved until the template is
        saved. All notes are automatically stamped with the username of the user
        who created the note and the date and time created.
      </p>
    </>
  );
};
